"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasLineGraphicsComponent = void 0;
const rc_js_util_1 = require("rc-js-util");
const core_1 = require("@visualization-tools/core");
const indexed2d_capped_line_value_provider_1 = require("./indexed2d-capped-line-value-provider");
const canvas_variable_width_capped_line_1 = require("./canvas-variable-width-capped-line");
// FIXME: this needs unit tests
/**
 * @public
 * Draws lines with or without segments of different colors and sizes.
 */
class CanvasLineGraphicsComponent {
    constructor() {
        this.type = core_1.EGraphicsComponentType.Entity;
        this.specification = {};
        this.transform = new core_1.NoTransformProvider();
        this.pointProvider = new PointProvider();
        this.valueProvider = new indexed2d_capped_line_value_provider_1.Indexed2dCappedLineValueProvider();
        this.cappedLine = new canvas_variable_width_capped_line_1.CanvasVariableWidthCappedLine(this.valueProvider);
    }
    getCacheId() {
        return "CanvasLine";
    }
    initialize() {
        // no action needed
    }
    onBeforeUpdate() {
        // no action needed
    }
    update(entity, renderer, updateArg) {
        if (entity.data.getLength() < 2) {
            return;
        }
        renderer.context.save();
        if (entity.data.getLength() < 3 || entity.data.offsets.size == null) {
            CanvasLineGraphicsComponent.drawConstantSizeLine(entity, renderer.context, updateArg);
        }
        else {
            this.drawLineWithPointSize(entity, renderer.context, updateArg, entity.data.offsets.size);
        }
        renderer.context.restore();
    }
    /**#
     * Only works with 3 points or more.
     */
    drawLineWithPointSize(entity, context, updateArg, sizeOffset) {
        const connector = entity.data;
        const xOffset = connector.offsets.x;
        const yOffset = connector.offsets.y;
        const userTransform = updateArg.userTransform;
        const sizeTransform = entity.graphicsSettings.pointSizeNormalizer.getSizeToPixelTransform();
        const cappedLine = this.cappedLine;
        this.pointProvider.update(entity, 0);
        this.valueProvider.update(entity, updateArg.drawTransforms.dataToInteractiveArea, sizeTransform, userTransform);
        cappedLine.beginLine(context, this.pointProvider.p1, this.pointProvider.p2);
        for (let i = connector.getStart() + 2, iEnd = connector.getEnd() - 1; i < iEnd; ++i) {
            cappedLine.setMidPoint(context, connector.getValue(i, xOffset), connector.getValue(i, yOffset), connector.getValue(i, sizeOffset), getColor(entity, i));
        }
        const last = connector.getEnd() - 1;
        cappedLine.endLine(context, connector.getValue(last, xOffset), connector.getValue(last, yOffset), connector.getValue(last, sizeOffset), getColor(entity, last));
    }
    static drawConstantSizeLine(entity, context, updateArg) {
        const connector = entity.data;
        const xOffset = connector.offsets.x;
        const yOffset = connector.offsets.y;
        const colorOffset = connector.offsets.color;
        const screenTransform = updateArg.drawTransforms.dataToInteractiveArea;
        const userTransform = updateArg.userTransform;
        const startIndex = connector.getStart();
        let xCanvas = screenTransform.getVec3MultiplyX(userTransform.forwardX(connector.getValue(startIndex, xOffset)));
        let yCanvas = screenTransform.getVec3MultiplyY(userTransform.forwardY(connector.getValue(startIndex, yOffset)));
        const defaultColor = rc_js_util_1.RgbaColorPacker.makeDomColorString(entity.graphicsSettings.pointDisplay.packedColor);
        const highlightColor = rc_js_util_1.RgbaColorPacker.makeDomColorString(entity.graphicsSettings.pointDisplay.packedHighlightColor);
        if (colorOffset == null) {
            context.strokeStyle = defaultColor;
        }
        context.lineWidth = entity.graphicsSettings.pointDisplay.getPixelSize();
        context.beginPath();
        context.moveTo(xCanvas, yCanvas);
        for (let i = startIndex + 1, iEnd = connector.getEnd(); i < iEnd; ++i) {
            if (colorOffset != null) {
                xCanvas = screenTransform.getVec3MultiplyX(userTransform.forwardX(connector.getValue(i, xOffset)));
                yCanvas = screenTransform.getVec3MultiplyY(userTransform.forwardY(connector.getValue(i, yOffset)));
                context.strokeStyle = isSegmentHighlighted(entity, i - 1)
                    ? highlightColor
                    : rc_js_util_1.RgbaColorPacker.makeDomColorString(entity.data.getValue(i, colorOffset));
                context.lineTo(xCanvas, yCanvas);
                context.stroke();
                context.beginPath();
                context.moveTo(xCanvas, yCanvas);
            }
            else {
                if (isSegmentHighlighted(entity, i - 1)) {
                    context.stroke();
                    context.beginPath();
                    context.moveTo(xCanvas, yCanvas);
                    context.strokeStyle = highlightColor;
                    xCanvas = screenTransform.getVec3MultiplyX(userTransform.forwardX(connector.getValue(i, xOffset)));
                    yCanvas = screenTransform.getVec3MultiplyY(userTransform.forwardY(connector.getValue(i, yOffset)));
                    context.lineTo(xCanvas, yCanvas);
                    context.stroke();
                    context.beginPath();
                    context.moveTo(xCanvas, yCanvas);
                    context.strokeStyle = defaultColor;
                }
                else {
                    xCanvas = screenTransform.getVec3MultiplyX(userTransform.forwardX(connector.getValue(i, xOffset)));
                    yCanvas = screenTransform.getVec3MultiplyY(userTransform.forwardY(connector.getValue(i, yOffset)));
                    context.lineTo(xCanvas, yCanvas);
                }
            }
        }
        if (colorOffset == null) {
            context.stroke();
        }
    }
}
exports.CanvasLineGraphicsComponent = CanvasLineGraphicsComponent;
class PointProvider {
    constructor() {
        this.p1 = new rc_js_util_1.Vec4.f64();
        this.p2 = new rc_js_util_1.Vec4.f64();
    }
    update(entity, index) {
        var _a, _b;
        const connector = entity.data;
        this.p1.update(connector.getValue(index, connector.offsets.x), connector.getValue(index, connector.offsets.y), connector.offsets.size == null ? 0 : connector.getValue(index, connector.offsets.size), (_a = getColor(entity, index)) !== null && _a !== void 0 ? _a : 0);
        this.p2.update(connector.getValue(index + 1, connector.offsets.x), connector.getValue(index + 1, connector.offsets.y), connector.offsets.size == null ? 0 : connector.getValue(index + 1, connector.offsets.size), (_b = getColor(entity, index + 1)) !== null && _b !== void 0 ? _b : 0);
    }
}
function getColor(entity, index) {
    if (isSegmentHighlighted(entity, index)) {
        return entity.graphicsSettings.pointDisplay.packedHighlightColor;
    }
    const colorOffset = entity.data.offsets.color;
    return colorOffset == null
        ? entity.graphicsSettings.pointDisplay.packedColor
        : entity.data.getValue(index, colorOffset);
}
function isSegmentHighlighted(entity, index) {
    const pointDisplaySettings = entity.graphicsSettings.pointDisplay;
    return pointDisplaySettings.highlightedSegments != null && pointDisplaySettings.highlightedSegments.has(index);
}
//# sourceMappingURL=canvas-line-graphics-component.js.map